{
  "version": 1,
  "asset_id": "2b4c78ab-bd72-4e7b-a99c-e82ce2374488",
  "project_id": "8cc9b1c1-0457-40cd-aa82-ea9e6032ce50",
  "url": "/__l5e/assets-v1/2b4c78ab-bd72-4e7b-a99c-e82ce2374488/pool-room-banner.webp",
  "r2_key": "a/v1/8cc9b1c1-0457-40cd-aa82-ea9e6032ce50/2b4c78ab-bd72-4e7b-a99c-e82ce2374488/pool-room-banner.webp",
  "original_filename": "pool-room-banner.webp",
  "size": 250446,
  "content_type": "image/webp",
  "created_at": "2026-07-04T16:13:11Z"
}
